import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import SellerHeader from "../../Components/SellerHeader";
import SellerSidebar from "../../Components/SellerSidebar";
import { productinventoryimg, sketch, upperarrow } from "../../Constant/Index";
import Select from "react-select";
import { useState } from "react";
import { WithContext as ReactTags } from "react-tag-input";
import AccessControl from "../../Components/Auth/AccessControl";
import SellerProductInventoryCard from "./SellerProductInventoryCard";
import { useEffect } from "react";
import AppService from "../../services/appServices";
import ReUse from "../../services/helpers/reUse";
import Pagination from "../Product/Pagination";
import GlobalModal from "../../Components/ReUse/Modals/GlobalModal";
import EditProduct from "./EditProduct";
function Sellerproductinventory() {
	const [apiData, setApiData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		const sellerGetProducts = AppService.sellerGetProducts({
			pageNumber: currentPage,
		});
		ReUse.getApiData(sellerGetProducts, setApiData, setLoading);
	}, []);

	const paginationProps = {
		apiData: apiData,
		setCurrentPage: setCurrentPage,
		currentPage: currentPage,
	};

	function openModal() {
		setModalIsOpen(true);
	}

	function closeModal() {
		setModalIsOpen(false);
	}

	return (
		<>
			<AccessControl allowedRoles={["seller"]}>
				<SellerHeader />
				<section className="seller-dashboard">
					<div className="container-fluid">
						<div className="row">
							<div className="col-lg-3 ps-0">
								<SellerSidebar />
							</div>
							<div className="col-lg-8">
								<div className="edit-profile-card edit-no-padding-right">
									<div className="edit-heading-wrapper">
										<h2>Product Inventory</h2>
									</div>

									<div className="add-product-btn">
										<Link to="/seller-adding-product">Add Product</Link>
									</div>

									<div className="seller-prdoduct-inventory-table">
										<table>
											<thead>
												<th className="for-border-all-raduis">Product Name</th>
												<th>Images</th>
												<th>Description</th>
												<th>Category </th>
												<th>Sub-Category</th>
												<th>Unit Price</th>
												<th>Action</th>
												<th>Stock</th>
												<th>Delete</th>
												<th>Edit</th>
												<th>Quantity</th>
												<th className="for-border-raduis-all-things">
													Discount Price
												</th>
											</thead>

											<tbody>
												{ReUse.mapItems(
													loading,
													apiData,
													SellerProductInventoryCard,
												)}
											</tbody>
										</table>
									</div>
									<Pagination paginationProps={paginationProps} />
								</div>
							</div>
						</div>
					</div>
				</section>
			</AccessControl>
		</>
	);
}

export default Sellerproductinventory;
